import { render, staticRenderFns } from "./RenewalDashboardManager.vue?vue&type=template&id=2a9040b4&scoped=true"
import script from "./RenewalDashboardManager.vue?vue&type=script&lang=js"
export * from "./RenewalDashboardManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9040b4",
  null
  
)

export default component.exports